import React from 'react';
import '../../../styles/admin/AdminLayout.css';

const AdminHeader = ({ title, onLogout }) => {
  return (
    <header className="admin-header">
      <div className="admin-header__title">{title}</div>
      <div className="admin-header__actions">
        {onLogout && (
          <button className="admin-header__logout-btn" onClick={onLogout}>
            로그아웃
          </button>
        )}
      </div>
    </header>
  );
};

export default AdminHeader;
